import { LayoutSDK } from '@notes/sticky-notes-layout'
import { getErrorAsString, IAuthenticatedUserInfo, isMsa } from '@notes/webintegrations-common'
import { getAppTokenInfoForStickyNotes } from '../shared/auth/getAppTokenInfoForStickyNotes'
import { IAuthContext } from '../shared/auth/IAuthContext'
import { SetTokenCase, SetTokenInSdkActivity } from '../shared/auth/SetTokenInSdkActivity'
import { Log } from '../shared/logger/Log'

export async function refreshTokensForSDK(layoutSDK: LayoutSDK, userInfo: IAuthenticatedUserInfo, authContext?: IAuthContext): Promise<void> {
  return await getTokensForSDK(layoutSDK, userInfo, 'refresh', authContext)
}

export async function getInitialTokensForSDK(layoutSDK: LayoutSDK, userInfo: IAuthenticatedUserInfo, authContext?: IAuthContext): Promise<void> {
  return await getTokensForSDK(layoutSDK, userInfo, 'initialSetToken', authContext)
}

async function getTokensForSDK(layoutSDK: LayoutSDK, userInfo: IAuthenticatedUserInfo, setTokenCase: SetTokenCase, authContext?: IAuthContext): Promise<void> {
  const getTokensForSdkActivity = new SetTokenInSdkActivity(userInfo.authType, setTokenCase)

  let outlookToken: string
  const authContextOutlookToken: string | undefined = authContext ? authContext.getSubstrateNotesToken() : undefined

  if (authContextOutlookToken) {
    Log.logger.info('Found tokens for SDK in auth context. Skip getting tokens.')

    outlookToken = authContextOutlookToken
  } else {
    Log.logger.info('Getting tokens for SDK...')
    try {
      const stickyNotesToken = await getAppTokenInfoForStickyNotes(userInfo, setTokenCase === 'refresh' /* forceRefresh */, authContext && authContext.getAccessToken())
      outlookToken = stickyNotesToken.outlookToken
    } catch (error) {
      getTokensForSdkActivity.finishWithFailure('ErrorWhenGettingAppToken', error)
      Log.logger.error(`AuthError: Getting initial notes token failed with error: ${getErrorAsString(error)}`)
      throw error
    }
  }

  try {
    if (isMsa(userInfo.authType)) {
      // If CID is available, send as mailbox hint, otherwise fallback to upn
      const mailboxHint = userInfo.userCid ? `CID:${userInfo.userCid}` : userInfo.upn
      await layoutSDK.setMSAAccessToken(outlookToken, mailboxHint)
    } else {
      // If PUID and TID are available, send as mailbox hint, otherwise fallback to upn
      const mailboxHint = userInfo.userPuid && userInfo.tenantId ? `PUID:${userInfo.userPuid}@${userInfo.tenantId}` : userInfo.upn
      await layoutSDK.setAADAccessToken(outlookToken, mailboxHint)
    }

    Log.logger.info('Successfully set tokens in SDK')
    getTokensForSdkActivity.finishWithSuccess()
  } catch (error) {
    getTokensForSdkActivity.finishWithFailure('ErrorWhenSettingTokenInSdk', error)
    Log.logger.error(`AuthError: Error when setting token in sdk: ${getErrorAsString(error)}`)
    throw error
  }
}
